{
	"title": "Content",
	"description": "De pagina's, veelgestelde vragen en nieuwsbrief van de shop.",
	"help": {
		"content": {
			"title": "Content",
			"area": "Content",
			"short": "Hier beheer je de teksten van de shop: de vaste pagina's, de veelgestelde vragen en de nieuwsbrief met de welkomstcode. Wat je publiceert, staat meteen in de shop.",
			"terms": ["page:pages", "faqItem:faq", "newsletter:newsletter", "newsletter:welcome"]
		}
	}
}
